import SingleButton from './SingleButton';

export default SingleButton;